import type { createListenerMiddleware } from '@reduxjs/toolkit';

import { clearCredentials } from '../slices/app/authCredentialsSlice';
import type { AppDispatch, RootState } from '../store';

export function authCredentialsListeners(mw: ReturnType<typeof createListenerMiddleware>) {
	const startAppListening = mw.startListening.withTypes<RootState, AppDispatch>();

	startAppListening({
		predicate: (action) => action.type === 'authCredentials/setCredentials',
		effect: async (_, api) => {
			const result = await api.condition((action) => action.type === 'authCredentials/clearCredentials', 10 * 60 * 1000);

			if (!result) {
				const state = api.getState();
				if (state.authCredentials.credentials) {
					api.dispatch(clearCredentials());
				}
			}
		},
	});

	startAppListening({
		predicate: (action) => action.type === 'authCredentials/clearCredentials',
		effect: (_, api) => {
			api.cancelActiveListeners();
		},
	});
}
